export const SET_SEARCH_INFO = 'setSearchInfo'
